<template>
<jet-dialog-modal :show="add_customer">
            <template #title>
                Kunden hinzufügen
            </template>

            <template #content>
                <div class="mt-6 md:grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    <div class="col-span-6">
                        <label for="name" class="block text-sm font-medium text-gray-700" >
                            Name
                        </label>
                        <div class="mt-1">
                            <input type="text" name="first_name" id="name" v-model="form.name" autocomplete="name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="form.errors.name" />
                        </div>
                    </div>
                    <div class="col-span-6">
                        <label for="email" class="block text-sm font-medium text-gray-700" >
                            E-Mail
                        </label>
                        <div class="mt-1">
                            <input type="text" name="email" id="email" v-model="form.email" autocomplete="email" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="form.errors.email" />
                        </div>
                    </div>
                    <div class="col-span-6">
                        <label for="kdnr" class="block text-sm font-medium text-gray-700" >
                            Kdnr überschreiben? (leer lassen, wenn nicht)
                        </label>
                        <div class="mt-1">
                            <input type="text" name="kdnr" id="kdnr" v-model="form.kdnr" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                            <jet-input-error :message="form.errors.kdnr" />
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-end">
                    <button @click="closeModal()" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Abbrechen
                    </button>
                    <button @click="createCustomer()" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Kunde erstellen
                    </button>
                </div>
            </template>
        </jet-dialog-modal>
</template>

<script>
import JetDialogModal from "@/Jetstream/DialogModal";
import JetInputError from "@/Jetstream/InputError";

export default {
  name: "CustomerModal",
  components: { JetDialogModal, JetInputError },
  props: ["add_customer", "farm"],
  data: function () {
  return {
        form: this.$inertia.form({
            name: '',
            email: '',
            kdnr: null,
        }),
  }
  },
  methods: {
    closeModal() {
      this.$emit("update:add_customer", false);
    },
    createCustomer() {
      this.form.post(route("farm.customers.store", { farm: this.farm }), {
        onSuccess: () => {
          this.closeModal();
        },
      });
    },
  },
};
</script>
